import { createAction, props } from '@ngrx/store';
import { EventWithDishes, Event, EventToCreate, EventToEdit } from '../../models/events';

export enum EventsActionTypes {
  LoadEvent = 'Load Event',
  LoadEventSuccess = 'Load Event Success',
  LoadEventError = 'Load Event Error',
  LoadUserEvents = 'Load User Events',
  LoadUserEventsSuccess = 'Load User Events Success',
  LoadUserEventsError = 'Load User Events Error',
  CreateEvent = 'Create Event',
  CreateEventSuccess = 'Create Event Success',
  CreateEventError = 'Create Event Error',
  UpdateEvent = 'Update Event',
  UpdateEventSuccess = 'Update Event Success',
  UpdateEventError = 'Update Event Error',
  ClearEvent = 'Clear Event',
  ClearEvents = 'Clear Events',
  ClearAll = 'Clear All',
}

export const loadEvent = createAction(
  EventsActionTypes.LoadEvent,
  props<{ eventId: string }>(),
);

export const loadEventSuccess = createAction(
  EventsActionTypes.LoadEventSuccess,
  props<{ event: EventWithDishes }>(),
);

export const loadEventError = createAction(
  EventsActionTypes.LoadEventError,
  props<{ errorMessage: string }>(),
);

export const loadUserEvents = createAction(
  EventsActionTypes.LoadUserEvents,
);

export const loadUserEventsSuccess = createAction(
  EventsActionTypes.LoadUserEventsSuccess,
  props<{ events: Event[] }>(),
)

export const loadUserEventsError = createAction(
  EventsActionTypes.LoadUserEventsError,
  props<{ errorMessage: string }>(),
)

export const createEvent = createAction(
  EventsActionTypes.CreateEvent,
  props<{ event: EventToCreate }>(),
);

export const createEventSuccess = createAction(
  EventsActionTypes.CreateEventSuccess,
  props<{ event: EventWithDishes }>(),
);

export const createEventError = createAction(
  EventsActionTypes.CreateEventError,
  props<{ errorMessage: string }>(),
);

export const updateEvent = createAction(
  EventsActionTypes.UpdateEvent,
  props<{ eventId: string, event: EventToEdit }>(),
);

export const updateEventSuccess = createAction(
  EventsActionTypes.UpdateEventSuccess,
  props<{ event: EventWithDishes }>(),
);

export const updateEventError = createAction(
  EventsActionTypes.UpdateEventError,
  props<{ errorMessage: string }>(),
);

export const clearEvent = createAction(
  EventsActionTypes.ClearEvent,
);

export const clearEvents = createAction(
  EventsActionTypes.ClearEvents,
);

export const clearAll = createAction(
  EventsActionTypes.ClearAll,
);
